"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addStyles = addStyles;
exports["default"] = exports.StaticMathField = exports.EditableMathField = void 0;

var _mathquill = _interopRequireDefault(require("mathquill/build/mathquill.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function addStyles() {
  if (document.getElementById('react-mathquill-styles') == null) {
    var styleTag = document.createElement('style');
    styleTag.setAttribute('id', 'react-mathquill-styles');
    styleTag.innerHTML = _mathquill["default"][0][1];
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(styleTag);
  }
}

var EditableMathField = require('./EditableMathField')["default"];

exports.EditableMathField = EditableMathField;

var StaticMathField = require('./StaticMathField')["default"];

exports.StaticMathField = StaticMathField;
var _default = EditableMathField;
exports["default"] = _default;